import { Overlay, createStyles } from '@mantine/core';

import dt from '~/domains/contest/domains/manage/domains/common/testing.const';
import { Text } from '~/domains/design-system/Text';

type SectionInProgressTemplateProps = {
  isNextSection: boolean;
};

const useStyles = createStyles((theme) => ({
  stack: {
    position: 'absolute',
    minHeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
    width: '100%',
    paddingTop: theme.other.spacing._8,
    marginBottom: theme.other.spacing._8,
    gap: theme.other.spacing._8,
    flexDirection: 'column',
    textAlign: 'center',
  },
  loader: {
    position: 'absolute',
    top: 72,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
  },
}));

export function SectionInProgressTemplate({ isNextSection }: SectionInProgressTemplateProps) {
  const { theme, classes } = useStyles();

  return (
    <div className={classes.loader}>
      <Overlay opacity={0.9} />
      <div data-test-id={dt.screen.submitted} className={classes.stack}>
        <Text mt={theme.other.spacing._8} variant="label-large">
          {isNextSection ? "Hang tight! We're setting up your contest." : 'Almost done!'}
        </Text>
      </div>
    </div>
  );
}
